import { gql } from 'apollo-boost';

export const EXTRACT_CAROUSEL_OCR = gql`
    mutation($data: ExtractCarouselOcrInput!) {
        extractCarouselOcr(data: $data) {
            id
        }
    }
`;
